import { Moment } from 'moment';
import { InputRef } from 'antd';
import { UpdateCheckInRoomModel } from 'core/domain/hotels/models';

export enum UpdateCheckInInputFormKey {
  CARD_1 = 'card1',
  CARD_2 = 'card2',
  CARD_3 = 'card3',
  CARD_4 = 'card4',
  CARD_5 = 'card5',
  CARD_6 = 'card6',
  CARD_7 = 'card7',
  CARD_8 = 'card8',
  CARD_9 = 'card9',
  CARD_LIST_BOX = 'cardListBox',
  DIGITAL_BOX = 'digitalBox',
  EMAILS = 'emails',
  END_TIME = 'endTime',
  MODAL_FORCE = 'modalForce',
  QR_MODAL = 'qrModal',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  START_TIME = 'startTime'
}

export type UpdateCardKey = 
  UpdateCheckInInputFormKey.CARD_1 |
  UpdateCheckInInputFormKey.CARD_2 |
  UpdateCheckInInputFormKey.CARD_3 |
  UpdateCheckInInputFormKey.CARD_4 | 
  UpdateCheckInInputFormKey.CARD_5 |
  UpdateCheckInInputFormKey.CARD_6 |
  UpdateCheckInInputFormKey.CARD_7 |
  UpdateCheckInInputFormKey.CARD_8 |
  UpdateCheckInInputFormKey.CARD_9;

export interface UpdateCheckInQrModalProps {
  title: string;
  cancelText: string;
  refreshText: string;
  checkText: string;
  selectedCard: UpdateCardKey;
  onCancel: () => void;
  onScanQr: (value: string) => void;
  onRefresh: () => void;
  onFollowingScan: (checked: boolean) => void;
  isVisible: boolean;
  isLoading: boolean;
  isFollowingScan: boolean;
}

export interface UpdateCheckInModalForceProps {
  acceptButtonText: string;
  cancelButtonText: string;
  checkInData: UpdateCheckInRoomModel;
  description: string;
  title: string;
  onAccept: () => void;
  onCancel: () => void;
  isLoading: boolean;
  isVisible: boolean;
}

export interface UpdateCheckInFormTextInputProps {
  errorMessage: string;
  label: string;
  placeholder: string;
  type?: string;
  isDisabled: boolean;
  isError: boolean;
  isRequired: boolean;
}

export interface UpdateCheckInFormEmailInputValueProps extends UpdateCheckInFormTextInputProps {
  value: string;
  valueList: string[];
  onChangeEmail: (value: string) => void;
  onRemoveEmailItemList: (emailItem: string) => void;
  onEmailSelected: (emailItem: string) => void;
  isValid: boolean;
}

export interface UpdateCheckInFormTextInputValueProps extends UpdateCheckInFormTextInputProps {
  value: string;
  onChangeValue: (value: string) => void;
}

export interface UpdateCheckInFormTextInputDateProps extends Omit<UpdateCheckInFormTextInputProps, 'isDisabled'> {
  formatDate: string;
  value: Moment | null;
  onChangeRange: (event: Moment | null) => void;
  onDisabledDate: (current: Moment) => boolean;
  isDisabled: boolean;
}

export interface UpdateCheckInFormTextInputTimeProps extends UpdateCheckInFormTextInputProps {
  formatTime: string;
  value: Moment | null;
  onChangeTime: ((value: Moment | null, dateString: string) => void) | undefined;
  onDisabledTime: (date: Moment | null) => {
    disabledHours: () => number[];
    disabledMinutes: () => number[];
  } | {
    disabledHours?: undefined;
    disabledMinutes?: undefined;
  };
}

export interface UpdateCheckInFormTextInputCardsProps extends UpdateCheckInFormTextInputProps {
  value: string;
  key: UpdateCardKey;
  followingKey: UpdateCardKey | null;
  ref: InputRef | null;
  onChangeValue: (value: string) => void;
  isVisible: boolean;
}

export interface UpdateCheckInFormBoxProps {
  title: string;
  onVisibleContent: (isVisible: boolean) => void;
  isContentVisible: boolean;
  isError: boolean;
}

export interface UpdateCheckInInitialStatesModel {
  [UpdateCheckInInputFormKey.CARD_1]: UpdateCheckInFormTextInputCardsProps;
  [UpdateCheckInInputFormKey.CARD_2]: UpdateCheckInFormTextInputCardsProps;
  [UpdateCheckInInputFormKey.CARD_3]: UpdateCheckInFormTextInputCardsProps;
  [UpdateCheckInInputFormKey.CARD_4]: UpdateCheckInFormTextInputCardsProps;
  [UpdateCheckInInputFormKey.CARD_5]: UpdateCheckInFormTextInputCardsProps;
  [UpdateCheckInInputFormKey.CARD_6]: UpdateCheckInFormTextInputCardsProps;
  [UpdateCheckInInputFormKey.CARD_7]: UpdateCheckInFormTextInputCardsProps;
  [UpdateCheckInInputFormKey.CARD_8]: UpdateCheckInFormTextInputCardsProps;
  [UpdateCheckInInputFormKey.CARD_9]: UpdateCheckInFormTextInputCardsProps;
  [UpdateCheckInInputFormKey.CARD_LIST_BOX]: UpdateCheckInFormBoxProps;
  [UpdateCheckInInputFormKey.DIGITAL_BOX]: UpdateCheckInFormBoxProps;
  [UpdateCheckInInputFormKey.EMAILS]: UpdateCheckInFormEmailInputValueProps;
  [UpdateCheckInInputFormKey.MODAL_FORCE]: UpdateCheckInModalForceProps;
  [UpdateCheckInInputFormKey.QR_MODAL]: UpdateCheckInQrModalProps;
  [UpdateCheckInInputFormKey.START_DATE]: UpdateCheckInFormTextInputDateProps;
  [UpdateCheckInInputFormKey.END_DATE]: UpdateCheckInFormTextInputDateProps;
  [UpdateCheckInInputFormKey.START_TIME]: UpdateCheckInFormTextInputTimeProps;
  [UpdateCheckInInputFormKey.END_TIME]: UpdateCheckInFormTextInputTimeProps;
}
